import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import createLogger from 'src/utils/logger';
import { modalWindows } from 'src/actions';

import Hackathons from 'src/components/Hackathons';

class ResetPasswordForm extends Component {
  constructor() {
    super();
    this.logger = createLogger('ResetPasswordForm');
  }
  componentDidMount() {
    const resetToken = this.props.location.state && this.props.location.state.resetToken; // eslint-disable-line react/prop-types
    if (!resetToken) {
      this.onMissingToken();
      return;
    }
    this.props.openResetPwdModal(resetToken);
  }

  onMissingToken = () => {
    this.logger.info('onMissingToken() redirecting to "/"');
    this.logger.debug('onMissingToken() location.state:', this.props.location.state);
    this.props.history.push('/');
  }

  render() {
    return (
      <Hackathons />
    );
  }
}



ResetPasswordForm.propTypes = {
  openResetPwdModal: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  location: PropTypes.object.isRequired,
}

function mapStateToProps() {
  return {};
}

export default withRouter(
  connect(mapStateToProps, {
    openResetPwdModal: modalWindows.openResetPwdModal,
  })(ResetPasswordForm));


// WEBPACK FOOTER //
// ./src/components/Authorization/ResetPassword.js